import { Card, CardContent, LinearProgress, Typography } from '@material-ui/core';
import { GeneralFactorsTable } from './GeneralFactorsTable';
import { FactorMeta } from '@pages/company-reputation-score/types';

interface Props {
  factors: Record<string, FactorMeta>;
  loading: boolean;
  error: boolean;
}

export const GeneralFactorsTab: React.FC<Props> = ({ factors, loading, error }) => {
  if (loading) {
    return <LinearProgress />;
  }

  if (error) {
    return <Typography color="error">Failed to load factors</Typography>;
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          General Scoring Factors
        </Typography>
        <GeneralFactorsTable factors={factors} />
      </CardContent>
    </Card>
  );
};
